import React from 'react';
import { buildPreviewDocument } from '../documentPreviewTemplate';
import '../Experiments.css';

// 문서 미리보기의 A4 자동 분할이 제대로 동작하는지 눈으로 확인하는 샘플.
function PageSplitSample() {
  const openPageSplitSample = () => {
    // 긴 콘텐츠를 .page 없이 전달 → JS가 자동 분할
    const manyRows = Array.from({length: 30}, (_, i) =>
      `<tr><td>항목 ${i+1}</td><td class="num">${((i+1)*150000).toLocaleString()}</td><td>비고 ${i+1}</td></tr>`
    ).join('');
    const sampleContent = `
<div class="contract-webview-sample">
  <h2>자동 분할 테스트 (계약서 스타일)</h2>
  <p>이 콘텐츠는 .page 래퍼 없이 전달됩니다. JS가 자동으로 페이지 경계를 계산하여 분할합니다.</p>
  <h2>제 1 조 [테스트 조항]</h2>
  <p>아래 표는 의도적으로 많은 행을 포함하여 한 페이지를 넘깁니다.</p>
  <table>
    <tr><th>구분</th><th>금액</th><th>비고</th></tr>
    ${manyRows}
  </table>
  <h2>제 2 조 [추가 조항]</h2>
  <p>표 이후의 내용입니다. 페이지가 자동으로 나뉘어야 합니다.</p>
  <table>
    <tr><th>항목</th><th>내용</th><th class="num">금액</th></tr>
    <tr><td>기본급</td><td>월정액</td><td class="num">3,000,000</td></tr>
    <tr><td>식대</td><td>비과세</td><td class="num">200,000</td></tr>
    <tr><td>합계</td><td></td><td class="num">3,200,000</td></tr>
  </table>
  <h2>제 3 조 [마무리]</h2>
  <p>위 계약 내용을 확인합니다.</p>
</div>
<div class="page">
  <h2>강제 분리 페이지 (동의서 샘플)</h2>
  <p>이 영역은 .page 래퍼로 감싸져 있어 항상 새 페이지에서 시작합니다.</p>
  <table class="contract-consent-table">
    <tr><th>항목</th><th>내용</th><th class="num">금액</th></tr>
    <tr><td>제공목적</td><td>인사관리</td><td class="num">-</td></tr>
  </table>
  <p>자동 분할과 강제 분할이 함께 동작하는지 확인하세요.</p>
</div>
`;
    const html = buildPreviewDocument(sampleContent, { mode: 'contract', pdfFilename: 'page-split-sample.pdf' });
    const win = window.open('', '_blank');
    if (!win) {
      alert('팝업이 차단되었을 수 있습니다. 팝업 허용 후 다시 시도해 주세요.');
      return;
    }
    win.document.write(html);
    win.document.close();
  };

  return (
    <div className="experiments-section experiments-section-doc-preview">
      <h3>문서 미리보기 · Page-split 샘플</h3>
      <p>아래 버튼을 누르면 긴 콘텐츠가 자동으로 A4 페이지 단위로 분할되어 표시됩니다.</p>
      <button type="button" className="experiments-btn-primary" onClick={openPageSplitSample}>
        Page-split 미리보기 샘플 열기
      </button>
    </div>
  );
}

export default PageSplitSample;
